import { render, staticRenderFns } from "./TaskCardCompany.vue?vue&type=template&id=61f17fae&"
import script from "./TaskCardCompany.vue?vue&type=script&lang=js&"
export * from "./TaskCardCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports